import React from "react";
import PropTypes from "prop-types";

export const getPlayoffByeCount = (playoffTeams) => {
    const spots = Math.max(0, Number(playoffTeams) || 0);
    if (spots < 2) return 0;
    return 2 ** Math.ceil(Math.log2(spots)) - spots;
};

export const getSimulationRowClassName = (index, playoffTeams, showByeEdge = true) => {
    const baseClassName = index % 2 === 0 ? "even-row" : "odd-row";
    const spots = Math.max(0, Number(playoffTeams) || 0);
    const byeTeams = getPlayoffByeCount(spots);

    if (showByeEdge && index < byeTeams) return `${baseClassName} simulation-row-bye`;
    if (index < spots) return `${baseClassName} simulation-row-playoff`;
    return baseClassName;
};

const SimulationPlayoffSummary = ({ playoffTeams, showByeChip = true }) => {
    const spots = Math.max(0, Number(playoffTeams) || 0);
    const byeTeams = getPlayoffByeCount(spots);

    if (!spots) return null;

    return (
        <div className="simulation-playoff-summary">
            <div className="standings-status-badges">
                {showByeChip && byeTeams > 0 && (
                    <span className="standings-status-badge standings-status-badge-bye">
                        Bye
                    </span>
                )}
                <span className="standings-status-badge standings-status-badge-playoff">
                    Playoff
                </span>
            </div>
            <p className="standings-summary-note">
                {spots} team{spots === 1 ? "" : "s"} make the playoffs
                {byeTeams > 0
                    ? `, with ${byeTeams} ${byeTeams === 1 ? "team" : "teams"} getting a bye.`
                    : "."}
            </p>
        </div>
    );
};

SimulationPlayoffSummary.propTypes = {
    playoffTeams: PropTypes.number,
    showByeChip: PropTypes.bool,
};

export default SimulationPlayoffSummary;
